import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'

const noop = () => {}

/** Always-open tooltip that carries a tour step; styled as a small app surface, not a hint bubble. */
const TourTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} open classes={{ popper: className }} onOpen={noop} onClose={noop} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        maxWidth: 320,
        padding: 0,
        borderRadius: 8,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.palette.mode === 'dark' ? '0 12px 32px rgba(0, 0, 0, 0.55)' : '0 8px 24px rgba(0, 0, 0, 0.14)',
        fontSize: 13,
        fontWeight: 400,
        lineHeight: 1.55,
        whiteSpace: 'normal',
        overflowWrap: 'break-word'
    }
}))

export default TourTooltip
